import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bulletin-home_text_newsbg",
  "use": "bulletin-home_text_newsbg-usage",
  "viewBox": "0 0 100 220",
  "content": "<symbol viewBox=\"0 0 100 220\" xmlns=\"http://www.w3.org/2000/svg\" id=\"bulletin-home_text_newsbg\"><rect x=\"8.01367\" y=\"124.336\" width=\"84\" height=\"18\" rx=\"3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol